import React from 'react';
import { Paragraph } from 'common-components/typography';
import { Radio, Row } from 'antd';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';
import _ from 'lodash';
import { EditRecurringMode } from 'utilities/enum-utils';
import { RadioChangeEvent } from 'antd/lib/radio';
import { Worker } from './types';

interface AssignWorkerStep6Props {
  selectedOption: EditRecurringMode | null;
  selectedWorker: Worker | null;
  isLoading: boolean;
  onChangeOption: (e: RadioChangeEvent) => void;
  onClose: () => void;
  checkForConflict: () => Promise<void>;
}

export const AssignWorkerStep6 = ({
  selectedOption,
  selectedWorker,
  isLoading,
  onChangeOption,
  onClose,
  checkForConflict,
}: AssignWorkerStep6Props) => {
  return (
    <>
      <div className='anim-slide-left'>
        <Paragraph>
          The booking you are editing is part of a recurring booking series. Please select one of the following options
          for editing this bookings.
        </Paragraph>
      </div>
      <div>
        <Radio.Group value={selectedOption} onChange={onChangeOption} className='ml-medium'>
          <Radio
            value={EditRecurringMode.Current}
            className={`${selectedOption === EditRecurringMode.Current && 'text-weight-bold'} mb-small `}
          >
            <div className='ml-medium inline-box inline-flex align-center' style={{ whiteSpace: 'normal' }}>
              Select {`${selectedWorker?.firstName} ${selectedWorker?.lastName}`} as the worker for this booking only.
            </div>
          </Radio>
          <br />
          <Radio
            value={EditRecurringMode.CurrentAll}
            className={`${selectedOption === EditRecurringMode.CurrentAll && 'text-weight-bold'} mb-small `}
          >
            <div className='ml-medium inline-box inline-flex align-center' style={{ whiteSpace: 'normal' }}>
              Select {`${selectedWorker?.firstName} ${selectedWorker?.lastName}`} as the worker for this booking and all
              following bookings where there is no worker assigned.
            </div>
          </Radio>
          <br />
        </Radio.Group>
      </div>
      <div className={'mt-large'}>
        <Row type={'flex'} justify={'end'}>
          <SecondaryButton className='mr-medium' disabled={isLoading} size='large' onClick={onClose}>
            Cancel
          </SecondaryButton>
          <PrimaryButton
            size='large'
            loading={isLoading}
            onClick={checkForConflict}
            disabled={
              ![EditRecurringMode.Current, EditRecurringMode.CurrentAll, EditRecurringMode.Upcoming].includes(
                selectedOption,
              )
            }
          >
            Continue
          </PrimaryButton>
        </Row>
      </div>
    </>
  );
};
